/**
 * Writes a CSV file in accordance with https://tools.ietf.org/html/rfc4180
 */
export class CsvWriter {
  constructor(options) {
    this._options = options;
    this._rows = [];
  }
  get _currentRow() { return this._rows[this._rows.length - 1]; }
  _quote(string) { return "\"" + string.replace(/"/g, "\"\"") + "\""; }
  pushValue(value) {
    const stringValue = (value === null || value === undefined) ? "" : value.toString();
    const needsQuote = stringValue.indexOf(this._options.delimiter) !== -1 || /["\r\n]/.test(stringValue);
    this._currentRow.push(needsQuote ? this._quote(stringValue) : stringValue);
  }
  createRow() { this._rows.push([]); }
  toString() {
    return this._rows.map(row => row.join(this._options.delimiter)).reduce((content, row) => content + "\r\n" + row);
  }
  toBlob() {
    const data = this._options.byteOrderMark ? [this._options.byteOrderMark, this.toString()] : [this.toString()];
    debugger;
    return new Blob(data, { type: this._options.contentType });
  }
}



// WEBPACK FOOTER //
// ./src/common/CSVExport/CsvWriter.js